import { render, staticRenderFns } from "./maintMsg.vue?vue&type=template&id=ed55b66e&scoped=true"
import script from "./maintMsg.vue?vue&type=script&lang=js"
export * from "./maintMsg.vue?vue&type=script&lang=js"
import style0 from "./maintMsg.vue?vue&type=style&index=0&id=ed55b66e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed55b66e",
  null
  
)

export default component.exports